import styled, { css } from 'styled-components'

export const Btn = styled.img`
    max-width: 100%;
`

export const Container = styled.div`
    position: absolute;
    z-index: 18;

    background-color: #2c3136;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08),
        0px 4px 12px -4px rgba(0, 0, 0, 0.08);

    transition: width 0.5s, height 0.5s;

    &:hover {
        height: 20%;
        ${props =>
            !props.teacher &&
            css`
                width: 20%;
            `}
    }

    ${props =>
        props.teacher
            ? css`
                  max-width: 60px;
                  max-height: 60px;
                  min-width: 30px;
                  min-height: 30px;
                  bottom: 1em;
                  right: 1em;
                  height: 7%;
                  aspect-ratio: 1/1;
                  &:after {
                      content: '';
                      display: block;
                      padding-bottom: 100%;
                  }
              `
            : css`
                  max-width: 50px;
                  max-height: 50px;
                  bottom: 14%;
                  right: 7%;
                  width: 12%;
                  height: 12%;
              `}

    border-radius: 50%;
    cursor: pointer;
    display: none;
    justify-content: center;
    align-items: center;
`
